import { render } from "./studioCourseXb.vue?vue&type=template&id=779a898c&scoped=true"
import script from "./studioCourseXb.vue?vue&type=script&lang=js"
export * from "./studioCourseXb.vue?vue&type=script&lang=js"

import "./studioCourseXb.vue?vue&type=style&index=0&id=779a898c&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779a898c"]])

export default __exports__